// eslint-disable-next-line import/prefer-default-export
export const NAV_ITEMS = [
  {
    label: '城市',
    value: 'CITY',
  },
  {
    label: '漫展',
    value: 'ACG_CONVENTION',
  },
  // {
  //   label: '演唱会',
  //   value: 'CONCERT',
  // },
  // {
  //   label: 'IP展',
  //   value: 'IP',
  // },
  {
    label: 'FAQ',
    value: 'QACON',
  },
]
